import React from "react";
import P from "prop-types";
import {
  BannerHeadling,
  BannerHeader,
  BannerDescription,
  Container,
  BannerContainer,
} from "./styles";

function Banner({ titulo, subtitulo }) {
  return (
    <Container>
      <BannerContainer>
        <BannerHeadling>
          <BannerHeader>{titulo}</BannerHeader>
          <BannerDescription>{subtitulo}</BannerDescription>
        </BannerHeadling>
      </BannerContainer>
    </Container>
  );
}

export default Banner;

Banner.propTypes = {
  titulo: P.string.isRequired,
  subtitulo: P.string.isRequired,
};
